/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Icon as $Icon, SemanticICONS } from 'semantic-ui-react';

export interface IconProps {
  name: SemanticICONS;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'big' | 'huge' | 'massive';
  disabled?: boolean;
  corner?: any;
}

export function Icon(props: IconProps) {
  const { name, size, disabled, corner } = props;
  return <$Icon name={name} corner={corner} size={size} disabled={disabled} />;
}
